import EventHandler from '@pixelunion/events';
import themeUtils from '../themeUtils';

export default class StaticNavigation {
  constructor(section) {
    this.el = section.el;
    this.events = new EventHandler();

    this.navigationWrapper = this.el.querySelector('[data-navigation-wrapper]');

    if (!this.navigationWrapper) return;

    this.navigationWrapper.classList.add('navigation--loading');

    this.reloadNavigation();

    this.navigationWrapper.classList.remove('navigation--loading');
    this.navigationWrapper.classList.add('navigation--loaded');
  }

  reloadNavigation() {
    this.events.unregisterAll();

    if (!themeUtils.isLessThanLarge()) {
      this.navigationContent = this.el.querySelector('.navigation-desktop[data-navigation-content]');

      const headerBranding = document.querySelector('[data-header-branding]');

      headerBranding.parentNode.insertBefore(this.navigationWrapper, headerBranding.nextSibling);

      const megaNavs = this.navigationContent.querySelectorAll('li[data-mega-nav="true"]');

      megaNavs.forEach(el => {
        el.classList.remove('has-dropdown');
        el.classList.add('has-mega-nav');
      });
    } else {
      this.navigationContent = this.el.querySelector('.navigation-mobile[data-navigation-content]');

      const headerMain = document.querySelector('[data-header-main]');

      headerMain.parentNode.insertBefore(this.navigationWrapper, headerMain.nextSibling);

      const megaNavs = this.navigationContent.querySelectorAll('li[data-mega-nav="true"]');

      megaNavs.forEach(el => {
        el.classList.add('has-dropdown');
        el.classList.remove('has-mega-nav');
      });
    }

    this.el.querySelectorAll('.mega-nav-list li a, .mega-nav-list li summary').forEach(anchor => this.events.register(anchor, 'mouseover', this._onMegaNavAnchorMouseover.bind(this)));
    this.el.querySelectorAll('.mega-nav-list a, .mega-nav-list summary').forEach(anchor => this.events.register(anchor, 'mouseleave', this._onMegaNavAnchorMouseleave.bind(this)));
    this.el.querySelectorAll('[data-header-nav-toggle]').forEach(toggle => this.events.register(toggle, 'click', this._onMobileNavigationClick.bind(this)));
    this.events.register(window, 'resize', themeUtils.debounce(this._onResize.bind(this), 500));

    const currentCloseAction = {
      el: null,
      timeout: null,
    };
    this.el.querySelectorAll('.has-dropdown, .has-mega-nav').forEach(toggle => this.events.register(toggle, 'mouseenter', event => {
      if (themeUtils.isLessThanLarge()) return;

      const { currentTarget } = event;

      if (currentCloseAction.el && currentCloseAction.timeout) {
        clearTimeout(currentCloseAction.timeout);
        this._closeDropdown(currentCloseAction.el);
        currentCloseAction.el = null;
        currentCloseAction.timeout = null;
      }

      if (currentTarget.classList.contains('has-mega-nav')) {
        this._swapMegaNavImages(currentTarget.querySelector('.mega-nav-image img'));
      }

      this._openDropdown(currentTarget);
    }));

    this.el.querySelectorAll('.has-dropdown, .has-mega-nav').forEach(toggle => this.events.register(toggle, 'mouseleave', event => {
      if (themeUtils.isLessThanLarge()) return;

      const { currentTarget } = event;

      if (currentCloseAction.el && currentCloseAction.timeout) {
        // Don't add another action for an element that is nested within a currently closing dropdown
        if (currentCloseAction.el.contains(currentTarget)) return;

        clearTimeout(currentCloseAction.timeout);

        // Close the current dropdown if one exists and hasn't been run, but only if it isn't a child of this new event
        if (!currentTarget.contains(currentCloseAction.el)) {
          this._closeDropdown(currentCloseAction.el);
        }
      }

      currentCloseAction.el = currentTarget;
      currentCloseAction.timeout = setTimeout(() => {
        this._closeDropdown(currentCloseAction.el);
        currentCloseAction.el = null;
        currentCloseAction.timeout = null;
      }, 400);
    }));

    this.detailsElements = this.el.querySelectorAll('[data-nav-details]');

    this.firstLevelDetails = [...this.el.querySelectorAll('.navigation-menu > .has-dropdown > [data-nav-details]')];

    this.click = e => {
      e.stopPropagation();

      const clickedParent = e.target.closest('.navigation-menu-link');
      const clickedDetailsEl = e.target.closest('[data-nav-details]');

      // Close siblings
      if (this.firstLevelDetails.includes(clickedDetailsEl)) {
        this.firstLevelDetails.forEach(detailsElement => {
          const details = detailsElement;
          if (details !== clickedDetailsEl) {
            details.open = false;
          }
        });
      }

      // If the link being clicked is a parent link, then take control of the navigation
      if (clickedParent && clickedParent.dataset.href) {
        e.preventDefault();
        // if already open, continue to link destination
        if (clickedDetailsEl.open) {
          window.location = clickedParent.dataset.href;
          return;
        }

        // If the submenu isn't open, open it
        clickedDetailsEl.open = true;
      }
    };

    if (themeUtils.isLarge()) {
      // Adding click event for details elements on desktop
      this.detailsElements.forEach(detailsElement => this.events.register(detailsElement, 'click', event => this.click(event)));
      this.detailsElements.forEach(detailsElement => this.events.register(detailsElement, 'touchend', e => this.click(e)));
    }

    this.el.querySelectorAll('.has-dropdown > a > [data-subnav-toggle]').forEach(toggle => this.events.register(toggle, 'click', event => {
      event.stopPropagation();
      event.preventDefault();

      const { currentTarget } = event;
      const triggerEl = currentTarget.parentElement.parentElement;

      if (triggerEl.classList.contains('has-dropdown--active')) {
        this._closeDropdown(triggerEl);
      } else {
        this._openDropdown(triggerEl);
      }
    }));

    this.el.querySelectorAll('.navigation-submenu').forEach(toggle => this.events.register(toggle, 'revealer-animating', event => {
      if (themeUtils.isLessThanLarge()) {
        return;
      }

      const { currentTarget: dropdown } = event;

      if (!dropdown.classList.contains('animating-in')) {
        return;
      }

      dropdown.classList.remove('navigation-submenu-open-left');
      dropdown.style.opacity = 0;
      dropdown.style.display = 'block';
      const navigationWidth = this.navigationWrapper.getBoundingClientRect().width;
      const offset = dropdown.getBoundingClientRect().left + window.pageXOffset;

      if ((offset + 200) > navigationWidth) {
        dropdown.classList.add('navigation-submenu-open-left');
      }

      dropdown.style.opacity = '';
      dropdown.style.display = '';
    }));
  }

  onSectionDeselect() {
    this._toggleMobileNavigation('close');
  }

  onSectionUnload() {
    this.events.unregisterAll();
    this._toggleMobileNavigation('close');
  }

  _onResize() {
    if (!themeUtils.isLessThanLarge()) {
      this._toggleMobileNavigation('close');
    }

    this.reloadNavigation();
  }

  _onMegaNavAnchorMouseover(e) {
    this._swapMegaNavImages(e.currentTarget.parentNode);
  }

  _onMegaNavAnchorMouseleave(e) {
    const megaNavImage = e.target
      .closest('.mega-nav')
      .querySelector('.mega-nav-image img');

    if (!megaNavImage) return;

    megaNavImage.setAttribute('src', megaNavImage.dataset.image);
    megaNavImage.setAttribute('alt', megaNavImage.dataset.alt);
  }

  _onMobileNavigationClick() {
    this._toggleMobileNavigation();
  }

  _openDropdown(triggerEl) {
    triggerEl.classList.add('has-dropdown--active');

    const navigationSubmenuToggle = triggerEl.querySelector('.navigation-submenu-toggle');

    if (themeUtils.isLessThanLarge()) {
      const dropdown = triggerEl.querySelector('.navigation-submenu');
      triggerEl.classList.add('has-mobile-dropdown--active');
      dropdown.classList.add('navigation-submenu-visible');
      this._setTierHeight();
    } else {
      const megaNav = triggerEl.querySelector('.mega-nav');
      const dropdown = triggerEl.querySelector('.navigation-submenu');

      if (megaNav) {
        megaNav.classList.add('visible');
      } else {
        dropdown.classList.add('navigation-submenu-visible');
        dropdown.classList.add('visible');
      }
    }

    navigationSubmenuToggle.setAttribute('aria-expanded', true);

    this.details = triggerEl.querySelector('[data-nav-details]');
    if (this.details && themeUtils.isLarge()) {
      this.details.open = true;
    }
  }

  _closeDropdown(triggerEl) {
    triggerEl.classList.remove('has-dropdown--active');
    triggerEl.querySelectorAll('.has-dropdown, .has-mega-nav').forEach(innerTriggerEl => this._closeDropdown(innerTriggerEl));

    const dropdown = triggerEl.querySelector('.navigation-submenu');
    const megaNav = triggerEl.querySelector('.mega-nav');
    const navigationSubmenuToggle = triggerEl.querySelector('.navigation-submenu-toggle');

    if (dropdown) {
      dropdown.classList.remove('navigation-submenu-visible');
      dropdown.classList.remove('visible');
    }

    triggerEl.classList.remove('has-mobile-dropdown--active');

    if (megaNav) {
      megaNav.classList.remove('visible');
    }
    this._setTierHeight();

    if (navigationSubmenuToggle) {
      navigationSubmenuToggle.setAttribute('aria-expanded', false);
    }

    this.details = triggerEl.querySelector('[data-nav-details]');
    if (this.details && themeUtils.isLarge()) {
      this.details.open = false;
    }
  }

  _toggleMobileNavigation(force = null) {
    if (document.body.classList.contains('mobile-nav-open') && force !== 'open') {
      this.navigationContent.removeAttribute('style');
      document.body.classList.remove('mobile-nav-open');
      document.body.classList.remove('lock-scroll');
      this.navigationContent.classList.remove('visible');
      this.navigationWrapper.classList.remove('visible');
      this.navigationWrapper.classList.remove('background');

      // Close opened menus on navigation close
      this.navigationContent.querySelectorAll('.has-dropdown--active').forEach(triggerEl => this._closeDropdown(triggerEl));
    } else if (!document.body.classList.contains('mobile-nav-open') && force !== 'close') {
      document.body.classList.add('mobile-nav-open');
      document.body.classList.add('lock-scroll');
      this.navigationWrapper.classList.add('visible');
      this.navigationWrapper.classList.add('background');
      this.navigationContent.classList.add('visible');
      this._setTierHeight();
    }
  }

  _setTierHeight() {
    this.navigationContent.style.overflowY = scroll;
    this.navigationContent.style.height = '100%';
  }

  _swapMegaNavImages(target) {
    if (!target) return;

    const { image, imageAlt } = target.dataset;

    if (image && (image !== '')) {
      const megaNavImg = target.closest('.mega-nav').querySelector('.mega-nav-image img');

      if (!megaNavImg) return;

      megaNavImg.setAttribute('src', image);
      megaNavImg.setAttribute('srcset', '');
      megaNavImg.setAttribute('alt', imageAlt);
    }
  }
}
